import { useState, Fragment, useEffect } from "react";
import DeviceSetupFormContainer from "src/components/device_management/serverDetails/steps/deviceSetupFormContainer";
import StepperNav from "src/components/device_management/serverDetails/steps/stepperNav";
import { InputWithInnerLabel } from "src/components/ui/inputFields/input-with-label";
import { GOOGlE_API_KEY } from "src/shared/config";
import GoogleMapReact from "google-map-react";
import { huaweiLogin, huaweiDeviceList } from "src/api/servers/huawei";
import Cookies from "js-cookie";
import {
  useGetBrand,
  useGetDeviceType,
  useGetPlace,
  useGetDeviceName,
} from "src/api/userInfo";
import { useGetServer } from "src/api/userInfo";

import huaweiConfigDetails from "./device_type_info.json";
import deviceTypeInfo from "./huawei_inverter.json";
import { useDeviceManagement } from "src/context/stores";
import { shallow } from "zustand/shallow";
import { useTranslation } from 'react-i18next'

// export const SetupHuaweiLogin = ({step,setStep,setDeviceDetails,deviceDetails, setHuaweiDeviceList, plantId}) => {
//     const [formStatus, setFormStatus] = useState({isError: false, message: ''})
//     const {serverList,isLoadingServerList,isErrorServerList} = useGetServer(plantId)
//     const huaweiServer = serverList?.server?.filter(server => server.type =="huawei-cloud")?.[0]
//     const [isLoading, setIsLoading] = useState(false);

//     // "username": "Sakayong_P",
//     // "password": "Huawei@1234"

//     const handleDeviceInfo = async (e) => {
//         e.preventDefault();

//         // get data from form
//         const formData = new FormData(e.target);

//         const data = await huaweiLogin(formData);
//         setIsLoading(true)
//         if(data?.success){
//             const deviceList = await huaweiDeviceList({csrfToken:data?.token, stationCode: huaweiServer?.station_code});

//             if(deviceList){
//                 setHuaweiDeviceList(deviceList?.data?.map((device)=>({
//                     label: device?.devName,
//                     value: device?.devName,
//                     deviceTypeId: device?.devTypeId,
//                     id: `${device?.id}`,
//                 })));

//                 setIsLoading(false)
//                 setStep(n => n+1)
//             }else{
//                 setIsLoading(false)
//                 setFormStatus({isError: "connection failed, please try again", message: false})

//             }

//         }else{
//             setIsLoading(false)
//             setFormStatus({isError: true, message: 'connection failed, please try again'})
//             setTimeout(() => {
//                 setFormStatus({isError: false, message: ''})
//             }, 5000);
//         }

//     }

//     return (
//         <DeviceSetupFormContainer
//             isLoading={isLoading}
//             handleSubmit={handleDeviceInfo}
//             formStatus={formStatus}
//             currentStep={2}
//             title="2. Huawei Cloud Login "
//             step={step} setStep={setStep}
//             isValid={true}
//             stepperPrev="< Select Server Type"
//             stepperNext={'Test Connection'}
//             isNextSubmit={true}>

//             <div className="relative grid w-full grid-cols-2 col-span-2 gap-4 mt-5">
//                 <InputWithInnerLabel
//                     label="username" name="username"
//                     placeholder="Vekin" required={true}
//                     defaultValue={"Sakayong_P"}
//                     // onChange={onInput('organization')}
//                     />

//                 <InputWithInnerLabel
//                     label="Password" name="password"
//                     placeholder="************" type='password'
//                     required={true}
//                     defaultValue={"Huawei@1234"}
//                     // onChange={onInput('organization')}
//                     // defaultValue={server?.station_code}
//                     />

//             </div>

//         </DeviceSetupFormContainer>

//      );
// }

// export const useDeviceManagement = create((set) => ({
//     isEditDevice: false,
//     deviceSetup: {},
//     deviceInfo:[],
//     huaweiDeviceList:[],
//     updateIsEditDevice: (isEditDevice) => set(() => ({ 'isEditDevice': isEditDevice })),
//     updateDeviceInfo: (deviceInfo) => set(() => ({ 'deviceInfo': deviceInfo })),
//     updateDeviceSetup: (useDeviceSetup) => set(() => ({ 'useDeviceSetup': useDeviceSetup })),
// }))

export const SetupHuaweiDeviceInfo = ({ step, setStep, setDeviceDetails,deviceDetails, huaweiDeviceList}) => {
    const { t } = useTranslation("settings");
  const updateDeviceInfo = useDeviceManagement(
    (state) => state.updateDeviceInfo,
    shallow
  );
  const [selectionList, huaweiModels] = useDeviceManagement(
    (state) => [state.selectionList, state.huaweiModels],
    shallow
  );
  const [updateDeviceSetup, deviceSetup, isEditDevice] = useDeviceManagement(
    (state) => [state.updateDeviceSetup, state.deviceSetup, state.isEditDevice],
    shallow
  );

  const modelSelectionList = isEditDevice ? selectionList?.modelSelectionList : selectionList?.huaweiModels;

  const [formStatus, setFormStatus] = useState({ isError: false, message: "" });
  // const { brandList } = useGetBrand()
  // const defaultDeviceType = deviceDetails?.config ? JSON.parse(deviceDetails?.config)?.external_type?.code :""
  // const modelSelectionList = brandList?.filter((brand)=>brand.name == "Huawei")?.[0]?.model?.map((model)=>({value: model.id, label: model.name}))

  const handleDeviceInfo = async (e) => {
    e.preventDefault();
    // get data from form
    const formData = new FormData(e.target);

    const model = formData.get("device_model");
    const device_name = formData.get("device_name");
    const deviceTypeId = formData.get("deviceTypeId");

    const description = formData.get("device_description");

    // const {deviceTypeId, id:devId} = huaweiDeviceList?.filter((device)=>device.value == device_name)?.[0]
    // const huaweiId = deviceDetails?.config?JSON.parse(deviceDetails?.config)?.external_type?.code:""
    const huaweiDeviceDetails = huaweiDeviceList?.filter(
      (device) => device.deviceTypeId == deviceTypeId
    )?.[0];

    const config = {
      performance: { renew: 1, load: 1 },
      external_type: {
        name: huaweiConfigDetails[deviceTypeId],
        code: deviceTypeId,
      },
    };

    // console.log(config, "config")

    if (device_name?.length < 1) {
      setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_name')}` });
    } else if (device_name.length <= 3) {
      setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_name_short')}` });
    } else if (!model) {
      setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_model')}` });
    } else {
      updateDeviceSetup({
        ...deviceSetup, // Spread the previous state
        name: device_name,
        model: Number(model),
        description: description,
        devTypeId: deviceTypeId,
        config: JSON.stringify(config),
        device_external_code: huaweiDeviceDetails?.id,
      });

      setStep((n) => n + 1);
    }

    setTimeout(() => {
      setFormStatus({ isError: false, message: "" });
    }, 5000);
  };

  // console.log(huaweiDeviceList);

  return (
    <DeviceSetupFormContainer
      isLoading={huaweiDeviceList?.length < 1}
      handleSubmit={handleDeviceInfo}
      formStatus={formStatus}
      currentStep={2}
      // title="2. Device Information "
      title={`2. ${t('device_management.device_setup.device_info')} `}
      step={step}
      setStep={setStep}
      isValid={true}
      // stepperPrev="< Test Connection"
      // stepperNext={"Device Field Details"}
      stepperPrev={`< ${t('device_management.device_setup.test_connection')} `}
      stepperNext={t('device_management.device_setup.field_details')}
      isNextSubmit={true}
    >
      <InputWithInnerLabel
        className="col-span-2"
        // label="Select Huawei Device"
        label={t('device_management.device_setup.selected_huawei')}
        name="deviceTypeId"
        placeholder="Solar22-41XXX"
        required={true}
        type="select"
        options={huaweiDeviceList}
        defaultValue={deviceSetup?.devTypeId}
        optionLabel="select Device"
      />

      <InputWithInnerLabel
        className="col-span-2"
        // label="Set Name for Device"
        label={t('device_management.device_setup.set_name')}
        name="device_name"
        placeholder="Solar22-41XXX"
        options={huaweiDeviceList}
        defaultValue={deviceSetup?.name}
        optionLabel="select device"
        // onChange={onInput('organization')}
      />

      <div className="relative grid w-full grid-cols-2 col-span-2 gap-4 mt-5">
        <InputWithInnerLabel
          // label="Device Brand"
          label={t('device_management.device_setup.device_brand')}
          name="device_brand"
          placeholder="Select Brand"
          readOnly={true}
          type="text"
          className="col-span-1"
          optionLabel="select brand"
          defaultValue={"Huawei"}
        />

        {/* <span className="absolute inline-flex items-center gap-1 text-xs font-light -top-6 text-vekin"> <i className=" ri-information-line text-vekin"></i>  To choose the model, you must first specify the brand.</span>  */}
        <InputWithInnerLabel
          // label="Device Model"
          label={t('device_management.device_setup.device_model')}
          name="device_model"
          placeholder="Select Model"
          required={true}
          disabled={!modelSelectionList}
          type="select"
          className="col-span-1"
          optionLabel="select model"
          defaultValue={deviceSetup?.model}
          options={modelSelectionList}
          // defaultValue={server?.station_code}
        />
      </div>

      <InputWithInnerLabel
        className="col-span-2"
        type="textarea"
        // label="Device Description"
        label={t('device_management.device_setup.device_description')}
        name="device_description"
        placeholder="description of the device"
        required={false}
        defaultValue={deviceSetup?.description}
        // onChange={onInput('organization')}
      />
    </DeviceSetupFormContainer>
  );
};

export const SetupHuaweiDeviceFields = ({
  step,
  setStep,
  setDeviceDetails,
  deviceDetails,
  huaweiDeviceList,
}) => {
  const { getDeviceType } = useGetDeviceType();
  const { t } = useTranslation("settings");
  const [updateDeviceSetup, deviceSetup, fieldProperties] = useDeviceManagement(
    (state) => [
      state.updateDeviceSetup,
      state.deviceSetup,
      state.fieldProperties,
    ],
    shallow
  );

  const { getDeviceName } = useGetDeviceName(deviceSetup?.devTypeId);
  // console.log(deviceSetup?.devTypeId, huaweiDeviceList, "huaweiDeviceList");

  const deviceTypeSelectionList = getDeviceType?.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  const [fieldInputs, setFieldInputs] = useState(fieldProperties);
  const [formStatus, setFormStatus] = useState({ isError: false, message: "" });

  const deviceProperties = deviceTypeInfo?.data?.filter(
    (d) => d?.deviceType == deviceSetup?.devTypeId
  )?.[0]?.deviceProperty;
  // const devicePropertySelection = deviceProperties?.map((property)=>({...property, value: property.name, label: property.name}))
  const devicePropertySelection = getDeviceName?.deviceProperty?.map(
    (property) => ({ ...property, value: property.name, label: property.name })
  );

  // useEffect(() => {
  //     if(deviceSetup?.property && JSON.parse(deviceSetup?.property)?.length > 0){
  //         setFieldInputs(JSON.parse(deviceSetup?.property))
  //     }
  // }, [step]);

  const onInputChange = (e) => {
    const { name, value: inputValue } = e.target;
    let previousState = { ...deviceSetup };

    if (name === "physical_type") {
      let device_type = deviceTypeSelectionList?.filter(
        (type) => type.value == inputValue
      )?.[0]?.label;
      if (device_type) {
        previousState = {
          ...deviceSetup,
          physical_type: Number(inputValue),
          type: device_type,
          device_type: device_type,
        };
      }
    } else if (name === "device_measurement") {
      previousState = { ...deviceSetup, measurement: inputValue };
    }
    updateDeviceSetup(previousState);
  };

  const handleDeviceInfo = async (e) => {
    e.preventDefault();
    // get data from form
    const formData = new FormData(e.target);
    const physical_type = formData.get("physical_type");
    const measurement = formData.get("device_measurement");
    const { isEmptyField } = formatFields(formData);

    // it was added to be used when getting field details, but its not need when saving the device
    // if (deviceSetup?.hasOwnProperty("devTypeId")) {
    //     delete deviceSetup["devTypeId"];
    // }

    if (!physical_type) {
      setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_physical_type')}` });
    } else if (!measurement) {
      setFormStatus({ isError: true, message: `${t('device_management.device_setup.required_measurement')}` });
    } else if (isEmptyField) {
      setFormStatus({
        isError: true,
        message: `${t('device_management.device_setup.required_field')}`,
      });
    } else {
      let device_type = deviceTypeSelectionList?.filter(
        (type) => type.value == physical_type
      )?.[0]?.label;
      updateDeviceSetup({
        ...deviceSetup, // Spread the previous state
        measurement: measurement,
        property: JSON.stringify(fieldInputs),
        physical_type: Number(physical_type),
        type: device_type,
        device_type: device_type,
      });
      setStep((n) => n + 1);
    }

    setTimeout(() => {
      setFormStatus({ isError: false, message: "" });
    }, 5000);
  };

  const formatFields = (formData) => {
    let isEmpty = false;
    fieldInputs?.forEach(({ address }) => {
      let name = formData?.get(`field_name_${address}`);

      if (!name) {
        isEmpty = true;
      }
    });
    return { isEmptyField: isEmpty };
  };

  const handleFields = (action, address = 0) => {
    switch (action) {
      case "add":
        setFieldInputs((prevState) => [
          ...prevState,
          { address: prevState.length + 1 },
        ]);
        break;
      case "remove":
        setFieldInputs((prevState) =>
          prevState?.filter((i) => i.address !== address)
        );
      default:
        break;
    }
  };

  const handleFieldInput = (address, value) => {
    //change the unit, field based on the index of fieldInputs
    const _selected_field = devicePropertySelection?.filter(
      (property) => property.name === value
    )?.[0];

    setFieldInputs((prevState) => {
      const indexToUpdate = prevState.findIndex(
        (obj) => obj.address === address
      );
      if (indexToUpdate === -1) {
        return prevState; // No matching object found, return the original state.
      }

      return prevState?.map((obj, index) =>
        index === indexToUpdate
          ? {
              name: _selected_field?.name,
              unit: _selected_field?.unit,
              field: _selected_field?.influx_field,
              type: "Float32",
              address: address,
            }
          : obj
      );
    });
  };


  return (
    <DeviceSetupFormContainer
      currentStep={3}
      handleSubmit={handleDeviceInfo}
      formStatus={formStatus}
      // title="3. Device Field Details "
      title={`3. ${t('device_management.device_setup.field_details')} `}
      step={step}
      setStep={setStep}
      isValid={true}
      // stepperPrev="< Device Information"
      // stepperNext={"Device Location"}
      stepperPrev={`< ${t('device_management.device_setup.device_info')} `}
      stepperNext={t('device_management.device_setup.device_location')}
      isNextSubmit={true}
    >
      <InputWithInnerLabel
        // label="Physical Type"
        label={t('device_management.device_setup.physical_type')}
        name="physical_type"
        placeholder="Select Type"
        required={true}
        type="select"
        className="col-span-1"
        optionLabel="select type"
        options={deviceTypeSelectionList}
        defaultValue={deviceSetup?.physical_type}
        onChange={onInputChange}
      />

      <InputWithInnerLabel
        className="col-span-1"
        // label="Measurement"
        label={t('device_management.device_setup.measurement')}
        name="device_measurement"
        placeholder="device measurement"
        // required={true}
        defaultValue={deviceSetup?.measurement}
        onChange={onInputChange}
      />

      <div className="col-span-2">
        <div className="flex flex-col w-full gap-2 max-h-[22rem] overflow-hidden overflow-y-scroll deviceSetup">
          {fieldInputs?.map(({ address, unit, field, name }, index) => (
            <div
              className="relative grid w-full grid-cols-4 gap-2 "
              key={index}
            >
              <InputWithInnerLabel
                className="col-span-2"
                // label={`${index + 1}. Field Name`}
                label={`${index + 1}. ${t('device_management.device_setup.field_name')}`}
                name={`field_name_${address}`}
                placeholder="device field name"
                required={true}
                type="select"
                defaultValue={name}
                options={devicePropertySelection}
                optionLabel="select field"
                onChange={(e) => handleFieldInput(address, e.target.value)}
              />
              <InputWithInnerLabel
                className="col-span-1 rounded-md"
                readOnly={true}
                // label="Field Unit"
                label={t('device_management.device_setup.field_unit')}
                name={`field_unit_${address}`}
                placeholder="kWh"
                // required={true}
                defaultValue={unit}
                // onChange={onInput('organization')}
              />
              <InputWithInnerLabel
                className="col-span-1 rounded-md"
                readOnly={true}
                // label="Field Value"
                label={t('device_management.device_setup.field_value')}
                name={`field_value_${address}`}
                placeholder="_ac_energy"
                // required={true}
                defaultValue={field}
                // onChange={onInput('organization')}
              />

              {fieldInputs.length > 1 && (
                <button
                  type="button"
                  className="absolute right-0 top-3"
                  onClick={() => handleFields("remove", address)}
                >
                  <i className="text-red-400 ri-close-circle-line"></i>
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="flex flex-row gap-2 pt-2 mt-1 border-t">
          <button
            type="button"
            onClick={() => handleFields("add")}
            className="hover:border-vekin transition inline-flex items-center gap-1 text-[10px] border rounded-md px-1"
          >
            <i className="text-sm ri-add-line"></i> {t('device_management.device_setup.add_field')}
          </button>
          <span className="inline-flex items-center gap-1 text-xs font-light text-vekin">
            <i className=" ri-information-line text-vekin"></i> {t('device_management.device_setup.suggested_field')}
          </span>
        </div>
      </div>
    </DeviceSetupFormContainer>
  );
};
